import { Component } from '@angular/core';
import { BackOfficeUserRole, User } from '../../models/user.model';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { MenuService } from '../../services/menu';
import { filter } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../environments/environment';
import { SiteInfoService } from '../../services/site-info/site-info.service';
import { UtilService } from '../../services/util.service';
import { Title } from '@angular/platform-browser';
import { FilterCaseParamService } from '../../services/ticket/filter-case-param.service';
import { FirebaseMessagingService } from '../../services/firebase-messaging/firebase-messaging.service';
import { NotificationService } from '../../services/notification/notification.service';

const BO_NAME = 'Back Office';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent {
  isCollapsed = false;

  isMobileView: boolean = false;
  leftMenuWidth: number = 0;
  isMenuCollapsed: boolean = false;
  logo: string = '';
  menuData: any[] = [];
  menuDataActivated: any[] = [];
  sessionUser: User | null = null;
  role: any;
  logoUrl = environment.logo;
  appName = environment.app;
  app = environment.app;
  version = environment.appVersion;
  currentParrent = '';
  siteName = BO_NAME;

  favIcon: any = document.querySelector('#favIcon');
  favIconUrl = environment.favi;
  constructor(
    private menuService: MenuService,
    private router: Router,
    private userService: UserService,
    private deviceService: DeviceDetectorService,
    private siteInfoService: SiteInfoService,
    private utilService: UtilService,
    private titleService: Title,
    private filterCaseParamService: FilterCaseParamService,
    private firebaseMessaging: FirebaseMessagingService,
    private notificationService: NotificationService
  ) {
    this.menuService.getMenuData().subscribe((menuData) => {
      this.favIcon.href = this.favIconUrl;
      this.sessionUser = this.userService.getCurrentUser();
      this.role = this.sessionUser.role;
      this.menuData = menuData;
      
      if (this.role == BackOfficeUserRole.CADDesigner || this.role == BackOfficeUserRole.ExternalQC) {
        this.menuData = this.menuData.filter(
          (menu) =>
            menu.key != 'customers' &&
            menu.key != 'products' &&
            menu.key != 'finance' &&
            menu.key != 'billing-statements' &&
            menu.key != 'users' &&
            menu.key != 'announcements' &&
            menu.key != 'reports' &&
            menu.key != 'automations' &&
            menu.key != 'faq'
        );
      }

      if (this.role == BackOfficeUserRole.QC) {
        this.menuData = this.menuData.filter(
          (menu) =>
            menu.key != 'finance' &&
            menu.key != 'billing-statements' &&
            menu.key != 'category' &&
            menu.key != 'announcements' &&
            menu.key != 'reports' &&
            menu.key != 'automations' &&
            menu.key != 'faq'
        );
      }

      if (this.role == BackOfficeUserRole.Accountant) {
        this.menuData = this.menuData.filter(
          (menu) =>
            menu.key != 'users' &&
            menu.key != 'announcements' &&
            menu.key != 'reports' &&
            menu.key != 'automations' &&
            menu.key != 'faq'
        );
      }

      if (
        this.role != BackOfficeUserRole.SuperAdmin &&
        this.role != BackOfficeUserRole.Admin &&
        this.role != BackOfficeUserRole.Accountant
      ) {
        this.menuData = this.menuData.map((menu) => {
          if (menu.key != 'finance' || !menu.subItem) {
            return menu;
          }

          return {
            ...menu,
            subItem: menu.subItem.filter((subItem: any) => subItem.key != 'billing-statements')
          };
        });
      }
    });
    this.favIcon.href = this.favIconUrl;
  }

  ngOnInit() {
    this.activateMenu(this.router.url);
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        let parrent = event.url.split('/')[2];
        console.log(event.url.split('/'));
        let change = false;
        if (this.currentParrent != parrent) {
          change = true;
          this.currentParrent = parrent;
        }

        const paths = event.url.split('/');
        if (paths && paths.length > 0) {
          const activeMenu = paths[1];
          this.menuDataActivated.forEach((menu) => {
            menu.selected = false;
            if (activeMenu.startsWith(menu.key)) {
              menu.selected = true;
              this.titleService.setTitle(
                this.appName + ' | ' + this.siteName + ' | ' + menu.title
              );
            }
          });
          console.log('active menu ', activeMenu)
          if (!activeMenu.startsWith('cases')){
            this.filterCaseParamService.resetFilter();
          }
        }

        // this.activateMenu(event.url);
      });
    this.loadSiteInfo();
    this.registerFCM();
  }

  activateMenu(url: any, menuData = this.menuData) {
    menuData = JSON.parse(JSON.stringify(menuData));

    if (this.role == 'bo.cad_designer' && url == '/customers') {
      this.router.navigate(['dashboard']);
    }
    this.menuDataActivated = menuData.slice();

    let currentUrl = this.router.url;
    const paths = currentUrl.split('/');
    if (paths && paths.length > 0) {
      const activeMenu = paths[1];
      this.menuDataActivated.forEach((menu) => {
        menu.selected = false;
        if (activeMenu.startsWith(menu.key)) {
          menu.selected = true;
          this.titleService.setTitle(
            this.appName + ' | ' + this.siteName + ' | ' + menu.title
          );
        }
      });
    }

    //get current menu
  }

  selectedMenu(item: any) {
    this.router.navigate([item.url]);
    this.menuDataActivated.forEach((menu) => {
      menu.selected = false;
      if (menu.key == item.key) {
        menu.selected = true;
      }
    });
  }

  gotoAccountMgnt() {
    this.router.navigate(['account/account-listing']);
  }

  checkCollapse() {
    const isMobile = this.deviceService.isMobile();
    if (isMobile) {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  async loadSiteInfo() {
    try {
      let sig = await this.siteInfoService.getSiteInfoGeneral();
      this.siteInfoService.getSiteInfoBranding().then( data => {
        if (data.logo){
          this.logoUrl = data.logo
        }
      })
      
      this.appName = sig.name;
    } catch (e) {
      this.utilService.showError(e);
    }
  }

  private async registerFCM() {
    try {
      const token = await this.firebaseMessaging.getTokenIfPermitted();
      if (token) {
        await this.notificationService.registerWebPushToken(token);
        console.log('Web push token registered with backend.');
      }
    } catch (error) {
      console.error('Error during FCM registration or backend registration:', error);
    }
  }
}
